module.exports = __webpack_public_path__ + "static/media/yanaeadvert.d7c8abb9.gif";